import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { mockBanners } from "@/mocks/products";

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % mockBanners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const banner = mockBanners[current];

  return (
    <section className="relative h-[560px] md:h-[640px] overflow-hidden">
      {mockBanners.map((b, i) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={b.image}
            alt={b.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full flex items-center px-6 lg:px-16">
        <div className="max-w-xl">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-3 py-1 mb-5">
            <div className="w-1.5 h-1.5 rounded-full bg-amber-400 animate-pulse"></div>
            <span className="text-amber-300 text-xs font-medium">跨境分銷平台 · 工廠直供</span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4">
            {banner.title}
          </h1>
          <p className="text-white/80 text-base md:text-lg mb-8 leading-relaxed">
            {banner.subtitle}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/products"
              className="px-6 py-3 bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              {banner.cta}
            </Link>
            <Link
              to="/register"
              className="px-6 py-3 border border-white/50 hover:border-white text-white font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              免費成為分銷商
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-6 mt-10">
            {[
              { value: "10,000+", label: "精選商品" },
              { value: "5,000+", label: "活躍分銷商" },
              { value: "98%", label: "好評率" },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-xl font-bold text-amber-400">{stat.value}</div>
                <div className="text-white/60 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {mockBanners.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              i === current ? "w-6 bg-amber-400" : "w-1.5 bg-white/40"
            }`}
          />
        ))}
      </div>

      {/* Arrows */}
      <button
        onClick={() => setCurrent((current - 1 + mockBanners.length) % mockBanners.length)}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-black/30 hover:bg-black/50 text-white transition-all cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      <button
        onClick={() => setCurrent((current + 1) % mockBanners.length)}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 flex items-center justify-center rounded-full bg-black/30 hover:bg-black/50 text-white transition-all cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </section>
  );
}
